<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store.dispatch("medicines/getDetails", this.itemId);
        },
  computed: {
    medicine() {
          return this.$store.state.medicines.medicine;
      }
  },
};
</script>